import { ApolloError } from "@apollo/client";
import { msg } from "@lingui/macro";
import { MessageDescriptor } from "@lingui/core";

export const DISCOUNT_ERROR_CODES = {
  CART_ERROR_APP_COUPON_ONLY: "cart_error_app_coupon_only",
  DISCOUNT_CODE_WAS_NOT_APPLIED: "DISCOUNT_CODE_WAS_NOT_APPLIED",
};

export const errorMessages: { [key: string]: MessageDescriptor } = {
  [DISCOUNT_ERROR_CODES.CART_ERROR_APP_COUPON_ONLY]: msg`cart_error_app_coupon_only`,
  [DISCOUNT_ERROR_CODES.DISCOUNT_CODE_WAS_NOT_APPLIED]: msg`This discount code was not applied.`,
};

const getErrorMessageCode = (
  error: ApolloError | undefined
): string | undefined => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return error?.graphQLErrors[0].extensions?.code as string | undefined;
};

export const getErrorMessage = (
  error: ApolloError | undefined
): MessageDescriptor | string => {
  const errorMessageCode = getErrorMessageCode(error);

  return errorMessageCode
    ? errorMessages[errorMessageCode] ||
        errorMessages[DISCOUNT_ERROR_CODES.DISCOUNT_CODE_WAS_NOT_APPLIED]
    : errorMessages[DISCOUNT_ERROR_CODES.DISCOUNT_CODE_WAS_NOT_APPLIED];
};
